// @flow
/*
import {
  setPartialUpdateDefaultSettings,
  partialUpdateConnectDatasetListeners,
  partialUpdateConnectLinksListeners,
  partialUpdateConnectFormsSubmitListeners,
  partialUpdateConnectHistory,
  execute,
  CursorSpinner,
} from 'fg-frontend';
*/


import { setPartialUpdateDefaultSettings }                  from 'fg-frontend/src/partialUpdate/PartialUpdateSettings';
import { partialUpdateConnectDatasetListeners }             from 'fg-frontend/src/partialUpdate/eventsFromDOMDatasetsRegister';
import partialUpdateConnectLinksListeners                   from 'fg-frontend/src/partialUpdate/connectLinksListeners';
import partialUpdateConnectFormsSubmitListeners             from 'fg-frontend/src/partialUpdate/connectFormsSubmitListeners';
import partialUpdateConnectHistory                          from 'fg-frontend/src/partialUpdate/connectHistory';
import { execute }                                          from 'fg-frontend/src/partialUpdate/partialUpdate';
import { onChangeXHRQueue as CursorSpinnerOnChangeHandler } from 'fg-frontend/src/components/CursorSpinner';
// import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';


import 'fg-frontend/plugins/jquery.simple-collapse';
import $ from 'jquery';
import {trim} from "ramda";

// nastavení defaultních vlastností partial updatu
setPartialUpdateDefaultSettings({
  onChangeXHRQueue: CursorSpinnerOnChangeHandler,
  // využívá se pro manipulaci s historií
  // je potřeba mít na všech stránkách jsPartialUpdate s id,
  // kde je nastaveno <partialUpdateAlterHistory>true</partialUpdateAlterHistory>
  globalTarget: 'dynamicArea',
  suppressRedirect: true,
});

document.addEventListener('partialUpdateComplete', ({ detail: { settings, hasError, newAccessibleTarget } }) => {
  const {
    type,
    url,
  } = settings;

  // po jakémkoliv přihlášení přes partial update se zaktualizují widgety související s přihlášením
  if (type === 'POST' && !hasError && url.startsWith(`/qf/${window.projectConfig.lang}/ramjet/performLogin`)) {
	  const includeTargets = [
		  'userMenu',
		  'userLists',
	  ].filter((targetId) => document.getElementById(targetId) != null);
	  const locationTargets = [
		  'partialUpdateContainer',
	  ].filter((targetId) => document.getElementById(targetId) != null);

	  // include widgety
	  if (includeTargets.length > 0) {
		  execute({
			  url: `/qf/${window.projectConfig.lang}/ramjet/include`,
			  target: includeTargets,
		  });
	  }
	  // PU obsah stranky
	  if (locationTargets.length > 0) {
        execute({
            url: location.href,
            target: locationTargets,
        });
	  }
  }

  // Dynamický title na stránkách Akce, Zprávy - Start, stránkování ve web.js
  if (document.getElementById('dynamicPageTitle')) {
    const dynamicPageTitle = document.getElementById('dynamicPageTitle').innerText;
    const dataDynamicPageTitle = document.getElementById('dynamicPageTitle');

    // Název Hasičovo
    const documentTitle = document.title;
    const documentTitleArray = documentTitle.split("-");
    const documentTitleLastInArray = documentTitleArray[documentTitleArray.length - 1].trim();

    const newDocumentTitle = dynamicPageTitle + ' - ' + documentTitleLastInArray;

    dataDynamicPageTitle.setAttribute('data-dynamic-page-title', dynamicPageTitle);

    if (document.title !== newDocumentTitle) {
      document.title = newDocumentTitle;
    }
  }
  if (document.getElementById('dynamicPagePerex')){
    const dynamicPagePerex = document.getElementById('dynamicPagePerex').innerText;
    const dataDynamicPagePerex = document.getElementById('dynamicPagePerex');

    dataDynamicPagePerex.setAttribute('data-dynamic-page-perex', dynamicPagePerex);
  }
  // Dynamický title na stránkách Akce, Zprávy - Stop

});

partialUpdateConnectDatasetListeners(['slideStop']);
partialUpdateConnectFormsSubmitListeners();
partialUpdateConnectLinksListeners({
  alterHistory: true,
});
partialUpdateConnectHistory();



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/configurePartialUpdate.js